export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

/**
 * Exclusive-by-time upper bound for a calendar day.
 *
 * The emissions API filters with `to_date <= :to_date::date`, so a `to` sent as
 * local midnight (e.g. `2026-12-31T00:00:00+05:30` -> `2026-12-30T18:30:00Z`)
 * is cast to the *previous* day in a UTC session and silently drops the last
 * day of the range. Anchoring to the end of the day keeps the cast on the
 * intended date in every session timezone.
 */
export function endOfDay(date: Date): Date {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999,
  );
}

/** Last day of `monthIndex` (0-based), anchored to the end of the day. */
export function endOfMonth(year: number, monthIndex: number): Date {
  return endOfDay(new Date(year, monthIndex + 1, 0));
}

/**
 * `YYYY-MM-DD` for the local calendar day. `toISOString().slice(0, 10)` shifts
 * the day for any timezone that is not UTC, so use this for display and for
 * `date`-typed values.
 */
export function toLocalIsoDate(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}
